











































import Vue from "vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default Vue.extend({
  name: "NotifyPage",
  components: {
    NotifyList: () => import("./notifyList.vue"),
    NotifyAddModal: () => import("./notifyAdd_modal.vue"),
    NotifySendModal: () => import("./notifySend_modal.vue")
  },
  data() {
    return {
      search: "",
      searchDebounce: null
    };
  },
  computed: {
    ...mapGetters({
      selectedNotify: "notify/selected"
    })
  },
  methods: {
    ...mapActions({
      getNotifys: "notify/getItems",
      deleteItems: "notify/deleteItems",
      filter: "notify/filter",
      searchAct: "notify/search",
      checkShowMenu: "menu/checkShowMenu"
    }),
    ...mapMutations({
      resetQuery: "notify/resetQuery",
      setAddItemModal: "notify/setAddItemModal"
    }),
    searchChanged(e) {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.searchAct(this.search);
      }, 500);
    },
    filterChanged(e) {
      if (e == "ALL") {
        this.filter({
          isBanner: undefined
        });
        return;
      }
      this.filter({
        isBanner: e == "BANNER"
      });
    },
    removeSelected() {
      const idItems = this.selectedNotify.map(item => item._id);
      this.deleteItems({ idItems, textMess: "thông báo" });
    },
    handleOpenModalAdd() {
      this.setAddItemModal({ show: true });
    }
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.resetQuery();
    this.getNotifys();
  }
});
